/* eslint-disable import/prefer-default-export */
import CEImg from '../../../../assets/images/covid-essentials_0.jpg';
import DBImg from '../../../../assets/images/diabetes_0.jpg';
import HPImg from '../../../../assets/images/homeopathy_0.jpg';

export const categoriesData = [
  { name: 'Covid Essentials', image: CEImg },
  { name: 'Diabetes', image: DBImg },
  { name: 'Homeopathy', image: HPImg },
  { name: 'Ayurvedic', image: CEImg },
  { name: 'Baby Care', image: DBImg },
  { name: 'Vitamins & Suppliments', image: HPImg },
];
